import { useAuth } from 'hooks/UseAuth'
import { TrackedChangeComment } from 'types'

export const useTrackedChangeCommentPermissions = (comment: TrackedChangeComment) => {
  const auth = useAuth()
  const isAuthor = auth?.id === comment.user.id

  return {
    canEdit: isAuthor,
    canDelete: isAuthor,
  }
}
